<template>
  <div class="ownerIndex">
    <div class="owner_box">
      <!-- 左边货主模块 -->
      <div class="o_left">
        <!-- 新增按钮 -->
        <div class="add_owner br4" @click="handleAddOwner">
          <i class="iconfont icon-tianjia"></i>
          <span>新增货主</span>
        </div>
        <!-- 搜索 -->
        <div class="list_search brt4">
          <input type="text" v-model="o_listQuery.name" @input="handleOwnerSearch()" placeholder="搜索货主" />
          <span class="icon_search"><i class="iconfont icon-sousuo" style="color:#888"></i></span>
          <span class="icon_close" v-if="o_listQuery.name" @click="o_listQuery.name = '';handleOwnerSearch()">
            <i class="iconfont icon-guanbi" style="color:#888"></i>
          </span>
        </div>
        <!-- 列表 -->
        <div class="ownerList_box">
          <div v-if="o_list.length>0">
            <md-scroll-view style="height:100%;" ref="ownerScrollView" :scrolling-x="false" @refreshing="handleOwnerListRefresh"  @end-reached="handleOwnerListMore" :auto-reflow="true" >
              <md-scroll-view-refresh roller-color="#31B158" slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }" :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive" ></md-scroll-view-refresh>
              <div class="owner_list">
                <div class="owner_list_item" v-for="(item,index) in o_list" :key="index" @click="handleClickOwner(item)">
                  <div :class="o_active_id== item.id?'active':''">
                    <span class="mand-ellipsis">{{item.name}}</span>
                  </div>
                </div>
              </div>
              <md-scroll-view-more :finished-text="o_list.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="o_isFinished" > </md-scroll-view-more>
            </md-scroll-view>
          </div>
        </div>
      </div>
      <!-- 右边货主详情模块 -->
      <div class="o_right">
        <ownerGoods ref="ownerGoods" v-if="o_active_id" @finish="handleFinish"></ownerGoods>
        <div v-else class="no_data brtl4">暂无数据</div>
      </div>
    </div>

    <!-- 添加货主 -->
    <addOwner ref="addOwner" @finish="handleFinish"></addOwner>
  </div>
</template>

<script>
import { owner_list }  from "@/api/work/owner";
import ownerGoods from "./ownerGoods";
import addOwner from "./addOwner";
export default {
  name: 'ownerIndex',
  components:{ownerGoods,addOwner},
  data(){
    return {
      // 左边数据
      o_isFinished:false,
      o_listQuery:{
        page:1,
        pageSize:10,
        name:'',
        status:"1"
      },
      o_list:[],
      o_active_id:'',
    }
  },
  created(){
    this.getOwnerList()
  },
  mounted(){

  },
  methods:{
    // 获取货主列表
    getOwnerList() {
      owner_list(this.o_listQuery).then(res=>{
        if(res.code == 200 ){
          if(this.o_listQuery.page == 1) this.o_list = []
          this.o_list = this.o_list.concat(res.data.list)
          // this.o_list =[]
          
          var active_item = null
          if(this.o_list.length > 0){
            for (let i = 0; i < this.o_list.length; i++) {
              const item = this.o_list[i];
              if(item.id == this.o_active_id){
                active_item = item
              }
            }
            if(!active_item){
              active_item = this.o_list[0]
            }
            this.o_active_id = active_item.id
          }
          if(this.o_list.length >= res.data.totalCount || res.data.list.length == 0){
              this.o_isFinished = true;
          }else{
              this.o_isFinished = false;
              this.o_listQuery.page++;
          }
          this.$nextTick(()=>{
            if(this.o_list.length > 0){
              this.$refs.ownerGoods.showBox(active_item)
              this.$refs.ownerScrollView.finishRefresh()
            }
          })
        }
      })
    },
    // 下拉刷新数据
    handleOwnerListRefresh() {
      this.o_listQuery.page = 1;
      setTimeout(()=>{
        this.getOwnerList()
      },500)
    },
    // 加载更多数据
    handleOwnerListMore(){
      if (this.o_isFinished) {
        return
      }
      this.$refs.ownerScrollView.finishLoadMore()
      this.getOwnerList()
    },
    // 输入框搜索
    handleOwnerSearch(){
      this.o_listQuery.page = 1
      this.getOwnerList()
    },

    // 完成操作
    handleFinish(){
      this.o_listQuery.page = 1;
      this.getOwnerList()
    },

    // 点击了某一个货主
    handleClickOwner(item){
      this.o_active_id = item.id
      this.$refs.ownerGoods.showBox(item)
    },

    // 点击了新增货主
    handleAddOwner(){
      this.$refs.addOwner.showPop()
    },
  }
}
</script>

<style lang="less" scoped>
.ownerIndex{
  position: relative;
  overflow: hidden;
  height: 100%;
  padding: 0.1rem;
  padding-bottom: 0;
  padding-right: 0;
  .owner_box{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .o_left{
    width: 1.8rem;
    height: 100%;
    position: relative;
    overflow: hidden;
    .add_owner{
      width: 1.8rem;
      height: 0.6rem;
      margin-bottom: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      // border-radius: 0.04rem;
      font-size: 0.24rem;
      background-color: #31B158;
      color: #fff;
      z-index: 2;
      position: relative;
      i{
        font-size: 0.20rem;
      }
      span{
        margin-left: 0.1rem;
        margin-right: 0.05rem;
      }
      &:active{
        background-color: #2c9f5d;
      }
    }
    .list_search{
      box-shadow: 0 0.02rem 0.04rem 0.01rem rgba(221,221,221,0.5);
      z-index: 2;
    }
    .ownerList_box{
      width: 100%;
      height: calc(100% - 0.6rem - 0.6rem);
      background-color: #fff;
      &>div{
        height: 100%;
        .owner_list_item{
          height: 0.75rem;
          border-bottom: 0.01rem solid #eee;
          &>div{
            width: 100%;
            height: 100%;
            padding: 0.08rem 0;
            padding-left: 0.15rem;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            &.active{    
              background-color: #31b158;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .o_right{
    width: calc(100% - 1.8rem - 0.1rem);
    height: 100%;
    position: relative;
    .no_data{
      width: 100%;
      height: 100%;
      background-color: #fff;
      font-size: 0.2rem;
      display: flex;
      align-items: center;
      color: #858B9C;
      justify-content: center;
    }
  }
}
</style>